import { useFetchAccountState } from "#/services/kyan/hooks/useFetchAccountState";
import { useStalePortfolios } from "#/store/wallet/account/stalePortfolios";

export const useRefetchAccountStateIfStale = () => {
  const { shouldFetchAccountState } = useStalePortfolios();
  const { refetch } = useFetchAccountState({
    options: {
      enabled: shouldFetchAccountState,
    },
  });

  return { refetch: shouldFetchAccountState ? refetch : undefined };
};
